define((require) => {
    "use strict";

    const _              = require("underscore");
    const AnimationModel = require("shared/ui/experience/widgets/animations/AnimationModel");

    /**
     * The model for a slide animation.
     *
     * @class SlideOutAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "slideOut",
            direction: "right"
        }, AnimationModel.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/slideOut/SlideOutAnimationModel.js